/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_DTOs_BookingFormQuestionDto } from '../models/Routemize_DTOs_BookingFormQuestionDto';
import type { Routemize_DTOs_CreateFormQuestionDto } from '../models/Routemize_DTOs_CreateFormQuestionDto';
import type { Routemize_DTOs_UpdateFormQuestionDto } from '../models/Routemize_DTOs_UpdateFormQuestionDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BookingFormQuestionService {
    /**
     * @param requestBody
     * @returns Routemize_DTOs_BookingFormQuestionDto OK
     * @throws ApiError
     */
    public static postApiAppBookingFormQuestionCreate(
        requestBody?: Routemize_DTOs_CreateFormQuestionDto,
    ): CancelablePromise<Routemize_DTOs_BookingFormQuestionDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/bookingFormQuestion/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppBookingFormQuestionCreateMany(
        requestBody?: Array<Routemize_DTOs_CreateFormQuestionDto>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/bookingFormQuestion/createMany',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAppBookingFormQuestionDelete(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/bookingFormQuestion/{id}/delete',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns Routemize_DTOs_BookingFormQuestionDto OK
     * @throws ApiError
     */
    public static getApiAppBookingFormQuestionGetById(
        id: string,
    ): CancelablePromise<Routemize_DTOs_BookingFormQuestionDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/bookingFormQuestion/{id}/getByID',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param formId
     * @returns Routemize_DTOs_BookingFormQuestionDto OK
     * @throws ApiError
     */
    public static getApiAppBookingFormQuestionGetFormQuestion(
        formId: string,
    ): CancelablePromise<Array<Routemize_DTOs_BookingFormQuestionDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/bookingFormQuestion/getFormQuestion/{formId}',
            path: {
                'formId': formId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_BookingFormQuestionDto OK
     * @throws ApiError
     */
    public static putApiAppBookingFormQuestionUpdate(
        requestBody?: Routemize_DTOs_UpdateFormQuestionDto,
    ): CancelablePromise<Routemize_DTOs_BookingFormQuestionDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/bookingFormQuestion/update',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
